export default __webpack_public_path__ + "static/media/question-mark-inactive-tournament.c86ad05e.svg";